var module = angular.module('octopusApp.environments');

module.directive('azureCloudServiceSelectorDeprecated', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      endpoint: '=',
      type: '@'
    },
    templateUrl: 'areas/environments/views/endpoints/azure_cloud_service_selector.html',
    controllerAs: 'vm',
    bindToController: true,
    controller: function ($scope, $q, octopusRepository, busy) {
      var vm = this;
      vm.isLoading = busy.create();

      vm.selectedCloudService = null;
      vm.selectedStorageAccount = null;


      vm.changed = function changed() {
        vm.endpoint.CloudServiceName = vm.selectedCloudService ? vm.selectedCloudService.Name : null;
        vm.endpoint.StorageAccountName = vm.selectedStorageAccount ? vm.selectedStorageAccount.Name : null;
      };


      $scope.$watch(function () {
                return vm.endpoint.AccountId;
              },
              function () {
                if (!vm.endpoint.AccountId) {
                  vm.cloudServices = [];
                  return;
                }


                vm.isLoading.promise(octopusRepository.Accounts.get(vm.endpoint.AccountId)
                        .then(function (account) {

                          vm.isLoading.promise(octopusRepository.Accounts.getCloudServices(account)
                                  .then(function (services) {
                                    vm.cloudServices = services;

                                    if (vm.endpoint.CloudServiceName) {
                                      vm.selectedCloudService = services.filter(function (service) {
                                        return vm.endpoint.CloudServiceName === service.Name;
                                      })[0];
                                    }
                                  }));

                          vm.isLoading.promise(octopusRepository.Accounts.getStorageAccounts(account)
                                  .then(function (storageAccounts) {
                                    vm.storageAccounts = storageAccounts;

                                    if (vm.endpoint.StorageAccountName) {
                                      vm.selectedStorageAccount = storageAccounts.filter(function (storage) {
                                        return vm.endpoint.StorageAccountName === storage.Name;
                                      })[0];
                                    }
                                  }));
                        }));
              }
      );
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/azure_cloud_service_selector.js
// module id = 2502248323761895
// module chunks = 1